import React, { useState } from 'react';
import axios from 'axios';
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";

const BaseUrl = process.env.REACT_APP_BASE_URL;

export default function ForgetPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [isSuccess, setIsSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const cookies = new Cookies();
  React.useEffect(() => {
    const token = cookies.get("token");
    if (token) {
      navigate("/dashboard");
    }
  }, [navigate]);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    setIsSuccess(null);

    try {
      await axios.post(`${BaseUrl}vendor/forgot_password`, { email });
      setIsSuccess(true);
      setMessage('Reset link sent! Please check your email.');
    } catch (err) {
      setIsSuccess(false);
      setMessage(err?.response?.data?.message || 'Failed to send reset link.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{ background: 'linear-gradient(135deg, #eca0a0ff 0%, #fff7ed 40%, #ffffff 100%)' }}
    >
      <style>
        {`
          .glass {
            backdrop-filter: blur(12px);
            background: rgba(255, 255, 255, 0.7);
            box-shadow: 0 10px 20px rgba(0,0,0,0.07);
            border: 1px solid rgba(255,255,255,0.3);
          }
        `}
      </style>

      <div className="glass rounded-4 p-4 p-md-5 w-100" style={{ maxWidth: 480 }}>
        <h2 className="fs-3 fw-bold text-dark mb-4 text-center">Forgot Password</h2>

        {message && (
          <div
            className={`alert ${isSuccess ? 'alert-success' : 'alert-danger'} text-center`}
            role="alert"
          >
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="d-grid gap-3">
          <div>
            <label htmlFor="email" className="form-label fw-semibold text-secondary">Email</label>
            <input
              id="email"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="form-control form-control-lg"
              required
              autoComplete="email"
            />
          </div>

          <button
            type="submit"
            className="btn btn-common btn-lg fw-semibold shadow-sm d-flex align-items-center justify-content-center"
            disabled={loading}
          >
            {loading && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />}
            {loading ? 'Sending…' : 'Send Reset Link'}
          </button>
        </form>
      </div>
    </div>
  );
}
